module.exports = __webpack_public_path__ + "81df64c7.svg";